import { InfoCircleIcon } from "../Icons"
import "./HelpInfo.scoped.scss"

export const HelpInfoHover = ({ children }) => {
	return (
		<div className="flex c-help-hover">
			<div className="c-help-icon">
				<InfoCircleIcon size={20} />
			</div>
			<div className="c-help absolute text-xs">{children}</div>
		</div>
	)
}
